export const BAZAK_LINK_HOST = 'link.bazak.ai';
